import {Component, forwardRef, OnInit, ChangeDetectorRef, Injector} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { LabelModel } from '../label.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'abw-label-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => LabelFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => LabelFormComponent),
        multi: true
      }
    ],
    templateUrl: './label-form.component.html',
    styleUrls: ['./label-form.component.scss']
})
export class LabelFormComponent extends AbstractWorkflowFormComponent<LabelModel, string> implements OnInit {
    trustedLabel: any;
    cleanLabel: string;

    constructor(
        protected _workflowComponentsService: WorkflowComponentsService,
        protected _cdf: ChangeDetectorRef,
		protected _injector: Injector,
        private sanitizer: DomSanitizer
    ) {
        super(_workflowComponentsService, _cdf, _injector);

    }

    ngOnInit() {
        this.trustedLabel = this.sanitizer.bypassSecurityTrustHtml(this.model.label);
        this.cleanLabel = this.model.label.replace(/<\/[^>]+(>|$)/g, "");
        this.propagateChange(this.model.label);
    }
}